import React, { useState, useEffect } from 'react';
import { TextField, Button, Checkbox, Container, FormControlLabel, InputLabel, Select, MenuItem, Typography, Grid, Box, RadioGroup, Radio } from '@mui/material';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { useTranslation } from 'react-i18next';
import { editIngredient, getIngredients, getUnitsOfMeasure } from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';

const EditIngredient = () => {
    const { t } = useTranslation('global');
    const { id } = useParams();

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [unitOfMeasure, setUnitOfMeasure] = useState('');
    const [amount, setAmount] = useState(0);
    const [unitPrice, setUnitPrice] = useState(0);

    const [unitsOfMeasure, setUnitsOfMeasure] = useState([]);

    const [errMsg, setErrMsg] = useState('');
    const [succ, setSucc] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Fetch units of measure
                const units = await getUnitsOfMeasure();
                setUnitsOfMeasure(units);

                // Fetch articles
                const ingredients = await getIngredients();
                const ingredient = ingredients.find(e => e.id.toString() === id);
                if(ingredient){
                    setName(ingredient.name);
                    setUnitOfMeasure(ingredient.unit_of_measure_id);
                    setAmount(ingredient.amount);
                    setUnitPrice(ingredient.unit_price);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!name || !amount || !unitPrice) {
            setErrMsg(t("edit.allFieldsAreRequired"));
            return;
        }

        const updatedIngredient = {
            id,
            name,
            unit_of_measure_id: unitOfMeasure,
            amount: amount,
            unit_price: unitPrice
        };

        try {
            const response = await editIngredient(updatedIngredient);
            if (response.success) {
                setSucc(t("edit.editSuccessful"));
                setTimeout(() => setSucc(''), 3000);
            } else {
                setErrMsg(t("edit.errorDuringEdit"));
                setTimeout(() => setErrMsg(''), 3000);
            }
        } catch (error) {
            setErrMsg(t("edit.errorDuringEdit"));
            setTimeout(() => setErrMsg(''), 3000);
        }
    };

    return (
        <Container maxWidth="sm" className="container-employee" sx={{ p: 3, flexShrink: 0, mt: 4 }} >
            <Typography variant="h4" sx={{ mb:4 }}>{t("ingredient.edit")}</Typography>
            <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
              <Grid container spacing={2}>
                         <Grid item xs={12}>
                                 <TextField
                                     label={t("ingredient.name")}
                                     fullWidth
                                     value={name}
                                     onChange={(e) => setName(e.target.value)}
                                 />
                         </Grid>
                         <Grid item xs={6}>
                             <Grid item xs={12} sm={12}>
                                 <Select
                                     fullWidth
                                     value={unitOfMeasure} // Koristi sektor kao vrednost
                                     onChange={(e) => setUnitOfMeasure(e.target.value)} // Postavi samo ID selektovanog sketora
                                     displayEmpty
                                 >
                                     <MenuItem value="" disabled>
                                     {t("ingredient.unitOfMeasure")}
                                     </MenuItem>
                                     {unitsOfMeasure.map((unit) => (
                                     <MenuItem key={unit.id} value={unit.id}>
                                         {unit.name}
                                     </MenuItem>
                                     ))}
                                 </Select>
                             </Grid>
                         </Grid>
                         <Grid item xs={6}>
                             <Grid item xs={12} sm={12}>
                                 <TextField
                                     label={t("ingredient.unitPrice")}
                                     fullWidth
                                     value={unitPrice}
                                     onChange={(e) => setUnitPrice(e.target.value)}
                                 />
                             </Grid>
                         </Grid>
                         <Grid item xs={12}>
                             <TextField
                                     label={t("ingredient.amount")}
                                     fullWidth
                                     value={amount}
                                     onChange={(e) => setAmount(e.target.value)}
                                 />
                         </Grid>
                         <Grid item xs={12} sm={6}>
                             <Button fullWidth variant="contained" type="submit">{t("edit.save")}</Button>
                         </Grid>
                         <Grid item xs={12} sm={6}>
                                                                                                               <Button
                                                                                                                 fullWidth
                                                                                                                 type="button"
                                                                                                                 variant="contained"
                                                                                                                 color="error"
                                                                                                                 onClick={() => { navigate('/new-ingredient') }}
                                                                                                               >
                                                                                                                 {t("editReader.cancel")}
                                                                                                               </Button>
                                                                                                             </Grid>
                     </Grid>
                 </form>

            {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
            {succ && <Success message={succ} onClose={() => setSucc('')} />}
        </Container>
    );
};

export default EditIngredient;
